// src/components/Header.js
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import {
  FaBars,
  FaHome,
  FaCog,
  FaInfoCircle,
  FaAddressBook,
  FaTimes,
  FaBriefcase,
  FaEuroSign,
  FaUserPlus
} from 'react-icons/fa';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('accueil');
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);

      // Détecter la section active seulement sur la page d'accueil
      if (location.pathname === '/') {
        const sections = ['accueil', 'services', 'apropos', 'contact'];
        const current = sections.find(section => {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            return rect.top <= 100 && rect.bottom >= 100;
          }
          return false;
        });

        if (current) {
          setActiveSection(current);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  return (
    <>
      {/* Navigation principale moderne */}
      <nav
        style={{
          background: isSticky ? 'rgba(255,255,255,0.95)' : 'white',
          backdropFilter: isSticky ? 'blur(10px)' : 'none',
          boxShadow: isSticky ? '0 4px 20px rgba(0,0,0,0.08)' : '0 2px 10px rgba(0,0,0,0.04)',
          padding: isSticky ? '10px 0' : '10px 0',
          transition: 'all 0.3s ease',
          position: 'sticky',
          top: '0',
          zIndex: 1030,
          borderBottom: '1px solid #f1f5f9'
        }}
      >
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <Link to="/" style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none'
            }}>
              <div className="me-2">
             <img 
               src="/logo.png" 
               alt="Minon Association Logo"
               style={{
                 width: '40px',
                 height: '40px',
                 borderRadius: '50%',
                 objectFit: 'cover'
               }}
             />
           </div>
              <div>
                <h3 style={{
                  margin: 0,
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1a202c',
                  lineHeight: '1.2'
                }}>Minon Association</h3>
              </div>
            </Link>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              style={{
                display: 'none',
                background: 'transparent',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                padding: '8px 12px',
                color: '#64748b',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              className="d-lg-none d-block"
              aria-label="Toggle navigation"
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#3b82f6';
                e.target.style.color = '#3b82f6';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.color = '#64748b';
              }}
            >
              {isMobileMenuOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
            </button>

            <div className={`d-lg-flex ${isMobileMenuOpen ? 'd-block' : 'd-none'}`} style={{
              position: isMobileMenuOpen ? 'absolute' : 'static',
              top: isMobileMenuOpen ? '100%' : 'auto',
              left: isMobileMenuOpen ? '0' : 'auto',
              right: isMobileMenuOpen ? '0' : 'auto',
              background: isMobileMenuOpen ? 'white' : 'transparent',
              boxShadow: isMobileMenuOpen ? '0 8px 25px rgba(0,0,0,0.1)' : 'none',
              borderRadius: isMobileMenuOpen ? '0 0 16px 16px' : '0',
              padding: isMobileMenuOpen ? '20px' : '0',
              marginTop: isMobileMenuOpen ? '8px' : '0',
              zIndex: 1000
            }}>
              <nav style={{
                display: 'flex',
                flexDirection: isMobileMenuOpen ? 'column' : 'row',
                alignItems: 'center',
                gap: isMobileMenuOpen ? '15px' : '0',
                marginLeft: 'auto'
              }}>
                {[
                  { text: 'Accueil', section: 'accueil', icon: <FaHome /> },
                  { text: 'Services', section: 'services', icon: <FaCog /> },
                  { text: 'À propos', section: 'apropos', icon: <FaInfoCircle /> },
                  { text: 'Contact', section: 'contact', icon: <FaAddressBook /> }
                ].map((item, index) => (
                  <Link
                    key={index}
                    to="/"
                    onClick={(e) => {
                      if (location.pathname === '/') {
                        e.preventDefault();
                        setTimeout(() => scrollToSection(item.section), 100);
                      } else {
                        setTimeout(() => {
                          window.location.href = `/#${item.section}`;
                        }, 100);
                      }
                      setIsMobileMenuOpen(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: isMobileMenuOpen ? '12px 16px' : '12px 20px',
                      margin: isMobileMenuOpen ? '0' : '0 4px',
                      color: (location.pathname === '/' && activeSection === item.section) ? '#3b82f6' : '#64748b',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      fontWeight: (location.pathname === '/' && activeSection === item.section) ? '600' : '500',
                      borderRadius: '10px',
                      transition: 'all 0.3s ease',
                      background: (location.pathname === '/' && activeSection === item.section) ? '#f1f5f9' : (isMobileMenuOpen ? '#f8fafc' : 'transparent'),
                      width: isMobileMenuOpen ? '100%' : 'auto',
                      gap: '8px',
                      position: 'relative'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#3b82f6';
                      e.target.style.background = '#f1f5f9';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#64748b';
                      e.target.style.background = isMobileMenuOpen ? '#f8fafc' : 'transparent';
                    }}
                  >
                    {isMobileMenuOpen && <span style={{ fontSize: '14px', color: '#3b82f6' }}>{item.icon}</span>}
                    {item.text}
                    {/* Indicateur actif */}
                    {(location.pathname === '/' && activeSection === item.section) && (
                      <div style={{
                        position: 'absolute',
                        bottom: '-2px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '24px',
                        height: '3px',
                        backgroundColor: '#3b82f6',
                        borderRadius: '2px',
                        display: isMobileMenuOpen ? 'none' : 'block'
                      }} />
                    )}
                  </Link>
                ))}
                
                {[
                  { text: 'Emploi', path: '/emploi', icon: <FaBriefcase />, color: '#f59e0b' },
                  { text: 'Tarifs', path: '/tarifs', icon: <FaEuroSign />, color: '#10b981' },
                  { text: 'Adhésion', path: '/adhesion', icon: <FaUserPlus />, color: '#8b5cf6' }
                ].map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: isMobileMenuOpen ? '12px 16px' : '12px 20px',
                      margin: isMobileMenuOpen ? '0' : '0 4px',
                      color: location.pathname === item.path ? '#3b82f6' : '#64748b',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      fontWeight: location.pathname === item.path ? '600' : '500',
                      borderRadius: '10px',
                      transition: 'all 0.3s ease',
                      background: location.pathname === item.path ? '#f1f5f9' : (isMobileMenuOpen ? '#f8fafc' : 'transparent'),
                      width: isMobileMenuOpen ? '100%' : 'auto',
                      gap: '8px',
                      position: 'relative'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#3b82f6';
                      e.target.style.background = '#f1f5f9';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#64748b';
                      e.target.style.background = isMobileMenuOpen ? '#f8fafc' : 'transparent';
                    }}
                  >
                    {isMobileMenuOpen && <span style={{ fontSize: '14px', color: item.color }}>{item.icon}</span>}
                    {item.text}
                    {location.pathname === item.path && (
                      <div style={{
                        position: 'absolute',
                        bottom: '-2px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '24px',
                        height: '3px',
                        backgroundColor: '#3b82f6',
                        borderRadius: '2px',
                        display: isMobileMenuOpen ? 'none' : 'block'
                      }} />
                    )}
                  </Link>
                ))}
                
                <Link
                  to="/"
                  onClick={(e) => {
                    if (location.pathname === '/') {
                      e.preventDefault();
                      setTimeout(() => scrollToSection('contact'), 100);
                    } else {
                      setTimeout(() => {
                        window.location.href = '/#contact';
                      }, 100);
                    }
                    setIsMobileMenuOpen(false);
                  }}
                  style={{
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: isMobileMenuOpen ? '14px 24px' : '12px 28px',
                    color: 'white',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(59,130,246,0.3)',
                    marginLeft: isMobileMenuOpen ? '0' : '15px',
                    width: isMobileMenuOpen ? '100%' : 'auto',
                    textTransform: 'none',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(59,130,246,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(59,130,246,0.3)';
                  }}
                >
                  {isMobileMenuOpen ? '📋 ' : ''}Devis Gratuit
                </Link>
              </nav>
            </div>
          </div>
        </Container>
      </nav>
    </>
  );
};

export default Header;